import { NavLink } from "react-router-dom";
import {CiFacebook} from "react-icons/ci"
import {AiOutlineInstagram} from "react-icons/ai"
import {RiTwitterXFill} from "react-icons/ri"
import "../Styles/Component/Footer.css"
import logo from "../assets/images/logo3.jpg"

const Footer = () => {

    return<>
        <footer>
            <div className="subscribe">
                <img src={logo} alt="" />
                <p>Stay Updated! Subscribe to our newsletter</p>
                <form action="">
                    <input type="email" name="" id="" placeholder="johndoe@gmail.com" />
                    <button>Subscribe</button>
                </form>
            </div>

            <ul>
                <h3>About Ecommerce</h3>
                <ul className="footer_menu">
                    <NavLink to={"/"}>Home</NavLink>
                    <NavLink to={"/product"}>Shop</NavLink>
                    <NavLink to={"/wishlist"}>Wishlist</NavLink>
                    <NavLink to={"/cart"}>Cart</NavLink>
                    <NavLink to={"/checkout"}>Checkout</NavLink>
                    <NavLink>Privacy Policy</NavLink>
                    <NavLink>Terms and Coniditions</NavLink>
                </ul>
            </ul>
            <ul>
                <h3>Categories</h3>
                <ul  className="footer_menu">
                    <NavLink>Vegetables </NavLink>
                    <NavLink>Fruits</NavLink>
                    <NavLink>Grains</NavLink>
                    <NavLink>Seafood</NavLink>
                    <NavLink>Legumes</NavLink>
                    <NavLink>Meat</NavLink>
                </ul>
            </ul>
            <ul>
                <h3>Connect With us</h3>
                <ul  className="footer_links">
                    <CiFacebook/>
                    <AiOutlineInstagram/>
                    <RiTwitterXFill/>
                </ul>
            </ul>
        </footer>
        <div className="copyright">
            &copy; All Rights Reserved, CodeSpace Hackers
        </div>
    </>

}

export default Footer;